import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { siteConfig } from '@/mocks/site-config';
import { testimonials } from '@/mocks/home-data';
import { useState } from 'react';

export default function AboutPage() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const current = testimonials[activeTestimonial];

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '吃瓜官网',
    alternateName: '51吃瓜官网入口',
    url: 'https://chigua.cn/',
    description: '吃瓜官网 — 51吃瓜在线第一入口，汇聚全网最新最全的黑料吃瓜与网红翻车现场。',
    email: 'contact@chigua.cn',
    telephone: '400-888-6666',
    foundingDate: '2022',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '望京SOHO T1-A座 18层',
      addressLocality: '北京市',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://chigua.cn/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://chigua.cn/about' },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="relative w-full min-h-[420px] md:min-h-[520px] flex flex-col items-center justify-start pt-28 md:pt-36 pb-16 overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20or%20media%20office%20with%20dramatic%20warm%20lighting%2C%20dark%20atmospheric%20interior%2C%20professional%20editorial%20environment%2C%20amber%20glow%20with%20deep%20shadows%2C%20luxurious%20contemporary%20aesthetic%2C%20no%20people&width=1920&height=700&seq=about-hero-bg&orientation=landscape"
                alt="关于吃瓜官网"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/85" />

            <div className="relative z-10 w-full text-center px-4">
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight">
                关于吃瓜官网
              </h1>
              <p className="mt-4 text-base md:text-lg text-background-50/60 max-w-lg mx-auto">
                做最专业的在线吃瓜平台，为吃瓜群众提供最新最全的独家爆料
              </p>
            </div>

            <div className="relative z-10 w-full max-w-4xl mx-auto mt-12 px-4">
              <div className="grid grid-cols-3 gap-4 md:gap-6">
                <div className="text-center p-4 md:p-6 rounded-xl bg-white/10 backdrop-blur-sm border border-white/10">
                  <div className="font-heading text-3xl md:text-4xl font-black text-primary-400">4年+</div>
                  <div className="text-xs md:text-sm text-background-50/60 mt-1">深耕吃瓜领域</div>
                </div>
                <div className="text-center p-4 md:p-6 rounded-xl bg-white/10 backdrop-blur-sm border border-white/10">
                  <div className="font-heading text-3xl md:text-4xl font-black text-accent-400">500万+</div>
                  <div className="text-xs md:text-sm text-background-50/60 mt-1">忠实吃瓜用户</div>
                </div>
                <div className="text-center p-4 md:p-6 rounded-xl bg-white/10 backdrop-blur-sm border border-white/10">
                  <div className="font-heading text-3xl md:text-4xl font-black text-primary-400">10000+</div>
                  <div className="text-xs md:text-sm text-background-50/60 mt-1">独家爆料内容</div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-8 bg-background-50">
            <div className="px-4 md:px-6 max-w-5xl mx-auto">
              <nav className="flex items-center gap-2 text-sm text-foreground-400" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line text-xs" />
                <span className="text-foreground-700 font-medium">关于我们</span>
              </nav>
            </div>
          </section>

          <section className="py-16 md:py-20" style={{ background: 'linear-gradient(180deg, #3d2e1e 0%, #2a1f14 100%)' }}>
            <div className="px-4 md:px-6 max-w-5xl mx-auto">
              <div className="inline-block px-4 py-1.5 bg-accent-100/20 text-accent-400 text-xs font-semibold rounded-full mb-6 whitespace-nowrap">
                关于我们 / About Us
              </div>
              <h2 className="font-heading text-3xl md:text-5xl font-black text-background-50 leading-tight max-w-2xl">
                吃瓜官网 — 你的专属在线吃瓜平台
              </h2>
              <p className="mt-6 text-sm md:text-base text-background-50/70 leading-relaxed max-w-2xl">
                吃瓜官网成立于2022年，是国内领先的在线吃瓜平台，汇聚51吃瓜官网入口与吃瓜官网免费资源。我们致力于为吃瓜群众提供最新、最全、最真实的独家爆料内容。从娱乐圈八卦到网红翻车现场，从黑料实锤到社会热点追踪，你想看的瓜，都在这里。
              </p>
              <p className="mt-4 text-sm md:text-base text-background-50/50 leading-relaxed max-w-2xl">
                我们拥有一支专业的调查记者团队，坚持"有图有真相"的原则，确保每一条爆料的真实性和可靠性。同时，我们严格保护爆料人的隐私安全，打造了一个安全、可信的爆料投稿渠道。
              </p>

              <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 mt-12">
                <div className="lg:w-1/2">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20media%20newsroom%20with%20warm%20ambient%20lighting%2C%20professional%20editorial%20workspace%2C%20dark%20wood%20and%20amber%20tones%2C%20luxurious%20contemporary%20office%2C%20clean%20aesthetic%2C%20no%20people&width=600&height=500&seq=about-brand-img&orientation=landscape"
                    alt="吃瓜官网编辑部"
                    title="吃瓜官网 · 专业编辑团队"
                    className="w-full rounded-xl object-cover"
                    style={{ height: '320px' }}
                  />
                </div>
                <div className="lg:w-1/2 flex flex-col justify-center">
                  <div className="font-heading text-7xl md:text-9xl font-black text-accent-400/30 leading-none">2022</div>
                  <p className="text-sm md:text-base text-background-50/70 leading-relaxed mt-2">
                    品牌创立于2022年，从最初的个人博客发展为如今拥有500万+忠实用户的专业吃瓜平台。我们见证了无数网红的崛起与坠落，记录了娱乐圈的风云变幻。
                  </p>
                  <p className="mt-3 text-sm md:text-base text-background-50/50 leading-relaxed">
                    我们的使命是：让每一个吃瓜群众都能第一时间获取真实、可靠的爆料信息，不传谣、不信谣，做理性的在线吃瓜人。
                  </p>
                  <Link
                    to="/category/hot"
                    className="mt-6 inline-flex items-center gap-2 w-fit px-6 py-2.5 bg-background-50/10 border border-background-50/20 text-background-50 font-label text-sm rounded-full hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    浏览最新爆料
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <section className="flex flex-col lg:flex-row">
            <div className="lg:w-1/2 relative h-[320px] md:h-[450px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Business%20handshake%20and%20partnership%20concept%20with%20dramatic%20warm%20lighting%2C%20dark%20atmospheric%20background%2C%20professional%20corporate%20scene%2C%20amber%20and%20golden%20highlights%2C%20editorial%20photography&width=960&height=650&seq=about-cta-bg&orientation=landscape"
                alt="商务合作"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
              <div className="absolute top-0 left-0 p-6 md:p-8">
                <span className="text-xs text-background-50/60 font-medium tracking-widest uppercase">合作共赢</span>
              </div>
              <div className="absolute bottom-0 left-0 p-6 md:p-8">
                <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-background-50 leading-none">
                  品牌合作
                  <br />
                  商务洽谈
                  <br />
                  共创共赢
                </h2>
              </div>
            </div>

            <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 md:px-12 py-12 md:py-16 bg-background-50">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 leading-tight text-center">
                与我们
                <br />
                携手合作
              </h2>
              <p className="mt-5 text-sm md:text-base text-foreground-500 text-center max-w-sm leading-relaxed">
                欢迎品牌方、广告主、内容创作者与我们联系。我们提供品牌推广、内容合作、爆料投稿等多种合作方式。期待与您共创吃瓜新生态。
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="px-7 py-3 bg-foreground-950 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap text-center group inline-flex items-center justify-center gap-2"
                >
                  商务洽谈
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                </a>
                <a
                  href={`tel:${siteConfig.phone}`}
                  className="px-7 py-3 border-2 border-foreground-200 text-foreground-800 font-label text-sm font-semibold rounded-full hover:border-primary-400 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap text-center"
                >
                  电话咨询
                </a>
              </div>
            </div>
          </section>

          <section className="relative py-16 md:py-20 bg-background-100">
            <div className="px-4 md:px-6">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">用户口碑</h2>
                <p className="mt-2 text-sm text-foreground-500">听听吃瓜群众怎么说</p>
              </div>

              <div className="relative max-w-4xl mx-auto">
                <div className="bg-foreground-950 rounded-2xl overflow-hidden">
                  <div className="flex flex-col lg:flex-row">
                    <div className="lg:w-[38%] relative">
                      <div className="h-[300px] lg:h-[400px] overflow-hidden">
                        <img
                          src={current.avatar}
                          alt={current.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/60 via-transparent to-transparent lg:bg-gradient-to-r lg:from-foreground-950/80 lg:via-foreground-950/30 lg:to-transparent" />
                    </div>
                    <div className="lg:w-[62%] flex flex-col justify-center px-6 md:px-10 py-8 md:py-10">
                      <span className="text-5xl md:text-6xl text-accent-400/30 leading-none select-none">&ldquo;</span>
                      <p className="text-base md:text-lg text-background-50/90 leading-relaxed -mt-4">
                        {current.content}
                      </p>
                      <div className="mt-6">
                        <p className="text-background-50 font-heading font-bold text-sm">{current.name}</p>
                        <p className="text-background-50/40 text-xs mt-0.5">{current.role}</p>
                      </div>
                      <div className="flex items-center gap-3 mt-8">
                        {testimonials.map((_, index) => (
                          <button
                            key={index}
                            onClick={() => setActiveTestimonial(index)}
                            className={`w-10 h-10 rounded-full flex items-center justify-center text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
                              index === activeTestimonial
                                ? 'bg-accent-400 text-foreground-950'
                                : 'bg-background-50/10 text-background-50/50 hover:bg-background-50/20'
                            }`}
                          >
                            {index + 1}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 md:py-20 bg-background-50">
            <div className="px-4 md:px-6 max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">联系我们</h2>
                <p className="mt-2 text-sm text-foreground-500">欢迎随时联系我们，期待与您的交流</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                <div className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="w-14 h-14 mx-auto rounded-full bg-primary-50 flex items-center justify-center">
                    <i className="ri-map-pin-line text-2xl text-primary-500" />
                  </div>
                  <h3 className="font-heading text-sm font-bold text-foreground-950 mt-4">公司地址</h3>
                  <p className="text-xs text-foreground-500 mt-2 leading-relaxed">{siteConfig.address}</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="w-14 h-14 mx-auto rounded-full bg-accent-50 flex items-center justify-center">
                    <i className="ri-phone-line text-2xl text-accent-500" />
                  </div>
                  <h3 className="font-heading text-sm font-bold text-foreground-950 mt-4">联系电话</h3>
                  <p className="text-xs text-foreground-500 mt-2">{siteConfig.phone}</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="w-14 h-14 mx-auto rounded-full bg-secondary-50 flex items-center justify-center">
                    <i className="ri-mail-line text-2xl text-secondary-500" />
                  </div>
                  <h3 className="font-heading text-sm font-bold text-foreground-950 mt-4">电子邮箱</h3>
                  <p className="text-xs text-foreground-500 mt-2">{siteConfig.email}</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}